












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVisitorsCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  planning: boolean;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    chartArea: { left: '200', top: '0', right: '20', bottom: '50' },
    legend: { position: 'bottom' },
    isStacked: true,
    colors: ['102D69', 'F5B830'],
    fontSize: 12
  };

  mounted() {
    this.load();
  }

  load() {
    this.chartData = [];
    if (this.planning) {
      this.chartData.push(['Usuário', 'Planejada', { role: 'annotation' }, 'Sem planejamento', { role: 'annotation' }]);
      this.kpis.forEach((i) => {
        this.chartData.push([
          `${StringUtils.abbreviate(i.nome, 25)} (${i.quantidadeTotal})`,
          i.planejadas,
          i.planejadas,
          i.naoPlanejadas,
          i.naoPlanejadas
        ]);
      });
    } else {
      this.chartData.push(['Usuário', 'Presencial', { role: 'annotation' }, 'Online', { role: 'annotation' }]);
      this.kpis.forEach((i) => {
        this.chartData.push([
          `${StringUtils.abbreviate(i.nome, 25)} (${i.quantidadeTotal})`,
          i.presenciais,
          i.presenciais,
          i.naoPresenciais,
          i.naoPresenciais
        ]);
      });
    }
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
